import React, { useState } from 'react';
import styles from '../../Pricing.module.css';

const faqData = [
  {
    q: 'What if I just want to try Fyntiq first?',
    a: 'Sign up for the Starter Plan to try invoicing and accounting basics. Upgrade to Pro whenever you need more — our plans are built for small businesses at every stage.',
  },
  {
    q: 'Do I automatically qualify for online payments on Pro?',
    a: 'Approval to accept online payments is subject to eligibility criteria, including identity verification and credit review. You\'ll answer a few questions about your business during setup.',
  },
  {
    q: 'Is it easy to cancel?',
    a: 'Yes — unsubscribe at any time. Cancellation takes effect at the end of your current billing period.',
  },
  {
    q: 'Can I change plans easily?',
    a: 'Yes. Sign in to your dashboard and click "Upgrade now" from invoicing or accounting to move to Pro. You can also change billing periods from your account settings.',
  },
  {
    q: 'Is the Pro subscription per owner or per business?',
    a: 'Pro is per business, not per owner. One Fyntiq account can manage multiple business profiles — each business on Pro needs its own subscription.',
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Pricing questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div
                className={styles.faqQ}
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}
              >
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
